import { SelectProps } from 'antd';

import './custom-tag.css';

type TagRender = SelectProps['tagRender'];

const CustomTag: TagRender = (props): React.ReactElement => {
  const { label } = props;

  return <div className="customTag">{label}</div>;
};

export default CustomTag;
